import { createStore } from 'vuex'
import VuexORM from '@vuex-orm/core'
import VuexORMSearch from '@vuex-orm/plugin-search'

import * as api from '@/api'
import database from '@/store/database'
import bus from '@/plugins/eventbus'
import modules from '@/store/modules'

VuexORM.use(VuexORMSearch)

const store = createStore({
  modules,
  plugins: [VuexORM.install(database)],
  strict: import.meta.env.NODE_ENV !== 'production',
  actions: {
    resetApp({ dispatch, commit }) {
      // Delete entire vuex data
      dispatch('entities/deleteAll')

      commit('collectionItems/reset')
      commit('collections/resetState')
    },
  },
})

// Add API and event bus to store for convenience
store.$api = api
store.$bus = bus

// Export setup function for Vue 3
export const setupStore = app => {
  app.use(store)

  // Make store instance available on app config for plugins
  app.config.globalProperties.$store = store
}

export default store
